<template>
  <div class="wrapper">
    <div class="container">
      <div class="row mb_80 pb_80px">
        <div class="col-12">
          <div class="ApTabs product-tabs-2 tabs-top">
            <h4 class="title_block">{{ title }}</h4>

            <div class="products_block">
              <div class="product-list-default">
                <carousel
                  style="width: 100%"
                  :breakpoints="breakpoints"
                  :settings="settings"
                  class="product_slider-carousel"
                  :wrap-around="true"
                >
                  <template #slides>
                    <slide v-for="item in products" :key="item.id">
                      <div v-if="item" class="item first px-2">
                        <article class="product-miniature">
                          <div class="thumbnail-container">
                            <div class="product-image product-image-carousel">
                              <a
                                :href="`/products/${item.id}`"
                                class="product-thumbnail"
                              >
                                <img
                                  class="img-fluid"
                                  :src="item.attachment"
                                  :alt="item.title"
                                />
                              </a>
                              <ul
                                class="product-flags"
                                v-if="item.discount"
                              >
                                <li class="product-flag discount">
                                  -{{ item.discount }}%
                                </li>
                              </ul>
                            </div>
                            <div class="product-meta">
                              <h3 class="product-title">
                                <a :href="`/product/${item.id}`">
                                  {{ cleanTitle(item.title) }}
                                </a>
                              </h3>
                              <div class="product-price-and-shipping">
                                <span
                                  class="regular-price"
                                  v-if="item.regularPrice && item.discount > 0"
                                >
                                  {{ item.regularPrice }}৳
                                </span>
                                <span class="price">{{ item.price }}৳</span>
                              </div>
                              <div class="product-description-short">
                                {{ item.description }}
                              </div>
                            </div>
                          </div>
                        </article>
                      </div>
                    </slide>
                  </template>

                  <template #addons>
                    <Navigation />
                  </template>
                </carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

const props = defineProps({
  title: { type: String, default: "Products" },
  products: { type: Array, default: () => [] }, // parent will pass products
});

const settings = ref({
  itemsToShow: 5,
  snapAlign: "start",
});

const breakpoints = ref({
  0: { itemsToShow: 1, snapAlign: "start" },
  350: { itemsToShow: 1.5, snapAlign: "center" },
  650: { itemsToShow: 2.5, snapAlign: "center" },
  1024: { itemsToShow: 3, snapAlign: "start" },
  1400: { itemsToShow: 5, snapAlign: "start" },
});

const cleanTitle = (title) => {
  return (title || "").replace(/&amp;/g, "&");
};
</script>
<style lang="scss">
.product_slider-carousel {
    .carousel__slide {}

    .carousel__prev,
    .carousel__next {
        width: 40px !important;
        height: 40px !important;
        background-color: white !important;
        border: 1px solid #e84f69 !important;
        border-radius: 100% !important;
    }

    .carousel__prev {
        margin-left: -2%;
    }

    .carousel__next {
        margin-right: -2%;
    }

    .carousel__prev,
    .carousel__next {
        font-size: 2rem;
        // color: #C3B090
    }

    @media screen and (max-width: 1023px) {
        
    .carousel__track {
  transform-style: preserve-3d;
}
    .carousel__slide--sliding {
  transition: 0.5s;
}

.carousel__slide {
  opacity: 0.9;
  transform: rotateY(-20deg) scale(0.9);
}

.carousel__slide--active ~ .carousel__slide {
  transform: rotateY(20deg) scale(0.9);
}

.carousel__slide--prev {
  opacity: 1;
  transform: rotateY(-10deg) scale(0.95);
}

.carousel__slide--next {
  opacity: 1;
  transform: rotateY(10deg) scale(0.95);
}

.carousel__slide--active {
  opacity: 1;
  transform: rotateY(0) scale(1.1);
}
}

}

.product-image-carousel {
  width: 248px;
  height: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
</style>